<template>
  <BreadCrumb :PageTitle="t('breadCrumb.contactsList')" />
  <ContactsList />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ContactsList from "../../components/CRM/ContactsList/ContactsList.vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "ContactsListPage",
  components: {
    BreadCrumb,
    ContactsList,
  },
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  }
});
</script>